import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import {
  COMMUNITIES_RESOURCE,
  UPDATE_COMMUNITY_RESOURCE,
  COMMUNITY_RESOURCE,
} from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const UpdateCommunityService = ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_COMMUNITY_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.getCommunity(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: COMMUNITIES_RESOURCE,
            idProp: 'id',
            id,
          },
          setOther: {
            resource: COMMUNITY_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateCommunityFailed'),
            onSuccessMessage: t('updateCommunitySuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateCommunityService;
